export enum SalesReportChartUnit {
  Piece = 1,
  Euro = 2
}

(SalesReportChartUnit as any).__typeName = 'SalesReportChartUnit';
